import { useLocale } from "../../i18n/LocaleProvider";
import { humanizeToolName, toolLabelKey } from "../../lib/toolLabel";
import { continuable, destructiveInFlight } from "./pending";
import type { ContinueState } from "./useContinueRun";
import "./continue.css";

/** lucide `Play`. */
const PLAY = (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4l14 8-14 8V4z" /></svg>
);

/**
 * A line in the workflow view's header when the conversation's last run stopped
 * before it finished: what happened, and Continue. With a destructive tool in
 * flight, the click first names it and asks — the user checks the model, then
 * continues anyway or sends a new message instead.
 */
export function ContinueBar({ state }: { state: ContinueState }) {
  const { t } = useLocale();
  if (!continuable(state.pending)) return null;
  const tools = destructiveInFlight(state.pending).map((name) => {
    const key = toolLabelKey(name);
    return key ? t(key) : humanizeToolName(name);
  });
  return (
    <div className="continue-bar" role="status" data-confirming={state.confirming || undefined}>
      <p className="continue-bar-text">
        {state.confirming ? t("workflows.continue.destructive", { tools: tools.join(", ") }) : t("workflows.continue.stopped")}
      </p>
      <div className="continue-bar-actions">
        {state.confirming ? (
          <button type="button" className="settings-btn secondary" onClick={state.dismiss}>{t("common.cancel")}</button>
        ) : null}
        <button type="button" className="settings-btn" onClick={state.onContinue}>
          {PLAY}
          {t(state.confirming ? "workflows.continue.confirm" : "workflows.continue.action")}
        </button>
      </div>
    </div>
  );
}
